import type { NeedType } from "@/types";

export const NEED_TYPES: NeedType[] = [
    {
        id: "RENFORT BE",
        label: "Renfort bureau d'études",
        placeholder:
            "Décrivez le projet, le type de charge à absorber (volume, durée, nature des tâches) et les compétences recherchées.",
    },
    {
        id: "CONCEPTION 3D",
        label: "Conception 3D",
        placeholder:
            "Décrivez l'ensemble à concevoir : fonction, encombrement disponible, interfaces avec l'existant et données déjà en votre possession.",
    },
    {
        id: "MISE EN PLAN",
        label: "Mise en plan",
        placeholder:
            "Décrivez la pièce ou l'ensemble concerné, les fichiers dont vous disposez et les livrables souhaités.",
    },
    {
        id: "RECONCEPTION",
        label: "Modification / reconception",
        placeholder:
            "Décrivez l'existant, les modifications souhaitées et les fichiers disponibles (plans, modèles, photos, relevés).",
    },
    {
        id: "DOSSIER FABRICATION",
        label: "Dossier fabrication",
        placeholder:
            "Précisez le dossier attendu : plans d'ensemble et de détail, fichiers de découpe, nomenclature, notes de fabrication.",
    },
    {
        id: "ÉTUDE TECHNIQUE",
        label: "Étude technique",
        placeholder:
            "Décrivez le contexte, la question technique à instruire et les données disponibles (croquis, mesures, contraintes).",
    },
    {
        id: "AUTRE",
        label: "Autre",
        placeholder:
            "Décrivez votre besoin et son contexte : SI2T identifie les points à clarifier avant estimation.",
    },
];

export const DEFAULT_PLACEHOLDER =
    "Décrivez votre besoin, son contexte et les données dont vous disposez.";

export const needTypeById = (id: string) => NEED_TYPES.find((n) => n.id === id);
